import { ShopTypeEnum } from 'components/AuthShop/components/ShopeeCNSCGuide';
import { atom, useAtom } from 'jotai';

const storeTypeAtom = atom<ShopTypeEnum | undefined>();

export const useChatDiversionDialog = () => {
  const [storeType, setStoreType] = useAtom(storeTypeAtom);

  const show = (storeType?: ShopTypeEnum) => setStoreType(storeType);
  const hide = () => setStoreType(undefined);

  return { visible: !!storeType, storeType, show, hide };
};
